import React, { useEffect } from 'react';
import { useAccount } from 'frontastic';
import Header from './header';

function Index({
  militaryStarApply,
  cartList,
  militaryStar,
  data,
  leftColumn,
  rightColumn,
  findStore,
  exchangeLogo,
  militaryStarParentURL,
}) {
  const { setExchangeLogoLink } = useAccount();
  useEffect(() => {
    setExchangeLogoLink(exchangeLogo?.icon?.media?.file);
  }, [exchangeLogo]);
  return (
    <>
      <Header
        menuData={data}
        leftColumn={leftColumn}
        rightColumn={rightColumn}
        findStore={findStore}
        exchangeLogo={exchangeLogo}
        militaryStar={militaryStar}
        militaryStarApply={militaryStarApply}
        cartList={cartList}
        militaryStarParentURL={militaryStarParentURL}
      />
    </>
  );
}

export default Index;
